const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SECTION_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "SECTION_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "SECTION_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
